import { t } from '@lingui/macro';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import Icon from '@material-ui/core/Icon';
import classnames from 'classnames';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { onChangeMapFilters } from '../../../ac/onChangeMapFilters';
import { StandardRadioGroup } from '../StandardRadioGroup';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer/LegendRenderer';
import { REG_TO_TRIP_CONVERSION_LEGEND } from '../../../constants/legends';
import styles from '../FilterSidebar.module.css';
const H3_ZOOMS = [ 6, 7, 8, 9, 10, 11, 12, 'auto' ];
const RegToTripConversionLegendComponent = ({ onChangeMapFilters, regToTripH3Zoom }) => {
    const [ isH3ZoomExpanded, setIsH3ZoomExpanded ] = useState(false);
    const handleH3ZoomChange = ({ target: { value } }) => {
        onChangeMapFilters('regToTripH3Zoom', value);
    };
    const toggleH3Zoom = () => {
        setIsH3ZoomExpanded(!isH3ZoomExpanded);
    };

    return (
        <div>
            <LegendRenderer config={REG_TO_TRIP_CONVERSION_LEGEND} />
            <div
                className={classnames(styles.legHead, {
                    [styles.expandableLegHead]: true,
                    [styles.expandableLegHeadOpen]: isH3ZoomExpanded,
                })}
                onClick={toggleH3Zoom}
                style={{ cursor: 'pointer', userSelect: 'none', display: 'inline-flex', alignItems: 'center' }}
            >
                {t`H3 Zoom`}:
                <Icon style={{ marginLeft: 'auto', transition: 'transform 0.25s ease' }}>expand_more</Icon>
            </div>
            {isH3ZoomExpanded && (
                <StandardRadioGroup
                    value={String(regToTripH3Zoom)}
                    onChange={handleH3ZoomChange}
                >
                    {H3_ZOOMS.map(zoom => (
                        <FormControlLabel
                            key={zoom}
                            className={styles.isochroneFilterLabel}
                            control={
                                <Radio
                                    checked={String(regToTripH3Zoom) === String(zoom)}
                                    onChange={handleH3ZoomChange}
                                    value={String(zoom)}
                                    className={classnames(
                                        styles.isochroneFilterInput, {
                                            [styles.checkedIsochroneFilterInput]: String(regToTripH3Zoom) === String(zoom),
                                        }
                                    )}
                                    size="small"
                                />
                            }
                            label={zoom}
                        />
                    ))}
                </StandardRadioGroup>
            )}
        </div>
    );
};
const mapStateToProps = ({ mapFilters: { regToTripH3Zoom } }) => ({ regToTripH3Zoom });
const ConnectedComponent = connect(mapStateToProps, { onChangeMapFilters })(RegToTripConversionLegendComponent);
export const RegToTripConversionLegend = withDisplayedLayersCheck(
    ConnectedComponent,
    'Конверсия из регистраций в старты'
);
